const timelineInjectionKey = Symbol("ArcoTimeline");
export { timelineInjectionKey };
